/**
 * Бренды
 */
export const BRANDS_BREAKPOINT = {
    breakpoints: {
        320: {
            spaceBetween: 20,
            slidesPerView: 3,
        },
        992: {
            spaceBetween: 16,
            slidesPerView: 5,
        },
    },
};

/**
 * Медиа
 */
export const MEDIA_BREAKPOINT = {
    spaceBetween: 16,
    breakpoints: {
        320: {
            slidesPerView: "auto",
        },
        479: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
        1280: {
            slidesPerView: 4,
        },
    },
};

/**
 * Отзывы
 */
export const REVIEWS_BREAKPOINTS = {
    breakpoints: {
        320: {
            spaceBetween: 12,
            slidesPerView: "auto",
        },
        479: {
            slidesPerView: 2,
            spaceBetween: 16,
        },
        720: {
            slidesPerView: 3,
            spaceBetween: 16,
        },
        992: {
            slidesPerView: 4,
            spaceBetween: 24,
        },
    },
};

/**
 * Сопутствующие товары
 */
export const RELATED_PRODUCTS_BREAKPOINT = {
    breakpoints: {
        320: {
            slidesPerView: 2,
            spaceBetween: 8,
        },
        992: {
            slidesPerView: 2,
            spaceBetween: 16,
        },
    },
};

/**
 * Похожие товары
 */
export const SIMILAR_PRODUCTS_BREAKPOINT = {
    breakpoints: {
        320: {
            slidesPerView: 2,
            spaceBetween: 8,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 16,
        },
    },
};

/**
 * Блок с гарантией
 */
export const GUARANTEE_BREAKPOINT = {
    breakpoints: {
        320: {
            slidesPerView: 1.3,
            spaceBetween: 40,
        },
        480: {
            slidesPerView: 2,
            spaceBetween: 24,
        },
        680: {
            slidesPerView: 3,
            spaceBetween: 24,
        },
        1025: {
            slidesPerView: 4,
            spaceBetween: 24,
        },
    },
};
